import { isEqual } from 'lodash';
import { atom, SetStateAction } from 'jotai';
import { atomWithDefault, RESET } from 'jotai/utils';
import { mapURLSearchParamsToBulkProvisioningFilers } from '@/activityLog/bulkProvisioning/Filters/utils/filtersToURLSearchParamsMapper';
import { createPaginationAtoms } from './utils/filtersFactory';
import { ProvisioningStatusFilter } from '@/activityLog/bulkProvisioning/constants/provisioningStatus';
import { focusAtom } from 'jotai-optics';
const { rowsPerPageFilterAtom, pageFilterAtom } = createPaginationAtoms();

export type ProductsManagementFilters = {
  fileName: string;
  status: ProvisioningStatusFilter;
  uploadDateFrom: Date | null;
  uploadDateTo: Date | null;
};

export const PRODUCTS_MANAGEMENT_INITIAL_VALUES: ProductsManagementFilters = {
  fileName: '',
  status: '',
  uploadDateFrom: null,
  uploadDateTo: null,
};

const filtersAtom = atomWithDefault(() => {
  const params = new URLSearchParams(globalThis.location.search);
  const filtersFromURL = mapURLSearchParamsToBulkProvisioningFilers(params);

  return {
    ...filtersFromURL,
    status: filtersFromURL.status,
  } as ProductsManagementFilters;
});

export const productsManagementFiltersAtom = atom(
  (get) => get(filtersAtom),
  (get, set, filters: SetStateAction<ProductsManagementFilters> | typeof RESET) => {
    const currentSimFilters = get(filtersAtom);
    if (!isEqual(currentSimFilters, filters)) {
      set(pageFilterAtom, 0);
    }
    if (filters === RESET) {
      return set(filtersAtom, { ...PRODUCTS_MANAGEMENT_INITIAL_VALUES });
    }

    return set(filtersAtom, filters);
  },
);

export const productsManagementRowsPerPageFilterAtom = rowsPerPageFilterAtom;
export const productsManagementPageFilterAtom = pageFilterAtom;
export const productsManagementFileNameFilterAtom = focusAtom(
  productsManagementFiltersAtom,
  (optic) => optic.prop('fileName'),
);
